import { GlobalToken } from 'antd/es/theme/interface'
import { CellValidator } from '../../../../helpers/cell-validators'
import { hasDmsInFinishing } from '../../../../helpers/is-dms-machine'
import CalculationPosition from '../../../../types/api/calculation-position'

export const validateLacquersDmsColumn: CellValidator = (
    record: CalculationPosition,
    token: GlobalToken
) => {
    if (!hasDmsInFinishing(record.additional_machines)) {
        return null
    }

    const lacquersDms = record.lacquersDms

    if (lacquersDms === undefined || lacquersDms === null || lacquersDms === 0) {
        return {
            message: 'Для станка DMS в отделке необходимо указать кол-во лаков DMS',
            bgColor: token.colorErrorBg,
            color: token.colorErrorText || token.colorError,
        }
    }

    return null
}
